<section class="container-fluid position-relative p-4 bg-gray-50 dark:bg-gray-900 analytics-container">

    <!-- Custom Tabs -->
    <div class="flex justify-between">
        <div class="flex gap-2 mb-3">
            <div class="tab-container">
                <div *ngFor="let tab of tabs; let i = index" class="outer-tab flex items-center" [ngClass]="{ 'active': activeTabIndex === i,
      'inactive': activeTabIndex !== i
     }" (click)="handleTabChange(i)">
                    <div class="tab">
                        <i class="pi" [ngClass]="tab.icon" style="margin-right: 10px;"></i>
                        <span>{{ tab.label }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- User and Year Select -->
        <div class="flex mb-5">
            <div class="flex " *ngIf="isUserLoading">
                <div><p-skeleton width="100%" height="40px"></p-skeleton></div>
                <div><p-skeleton width="100%" height="40px"></p-skeleton></div>
            </div>

            <div class="flex gap-3" *ngIf="!isUserLoading">
                <div *ngIf="isAdmin">
                    <p-select [options]="users" optionLabel="name" optionValue="id" placeholder="-- All Users --"
                        [(ngModel)]="selectedUser" (onChange)="fnChangeUser($event.value)">
                    </p-select>
                </div>
                <div>
                    <p-select [options]="years" placeholder="Select Year" [(ngModel)]="selectedYear"
                        (onChange)="fnChangeYear($event.value)">
                    </p-select>
                </div>
            </div>
        </div>
    </div>

    <hr style="margin-top: -10px;">

    <!-- Leads Tab Content -->
    <div *ngIf="activeTabIndex === 0">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 mb-8">
            <p-card *ngFor="let card of leadsCards"
                class="w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">

                <div class="flex flex-col items-center text-center p-4">

                    <div
                        class="flex items-center justify-center w-12 h-12 mb-2 rounded-full bg-blue-100 dark:bg-blue-900">
                        <!-- dynmic icons -->
                         <i class="pi" [ngClass]="card.icon" style="font-size: 25px;"></i>
                    </div>

                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-2 mt-1">
                        {{ card.title }}
                    </h3>

                    <!-- Loader or Value -->
                    <div class="w-full flex justify-center mt-2">
                        <ng-container *ngIf="!leadLoading; else loader">
                            <div class="text-3xl font-bold text-blue-600 dark:text-blue-400">
                                {{ card.value || 0 }}
                            </div>
                        </ng-container>
                        <ng-template #loader>
                            <!-- <div class="w-16 h-8 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div> -->
                            <p-skeleton width="120px" height="20px"></p-skeleton>
                        </ng-template>
                    </div>

                </div>
            </p-card>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">

            <p-card class="col-span-full rounded-xl shadow-lg">
                <div *ngIf="!leadLoading; else chartLoader">
                    <app-multi-line-chart [id]="'multiLineChart'" [id]="'total_leads'" [Title]="'Total Leads'"
                        *ngIf="!leadLoading" [data]="leadsAnalytics?.platform_wise_leads">
                    </app-multi-line-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>

            <p-card class="rounded-xl shadow-lg h-full"
            [style]="{ 'height': '100%'}"
            >
                <div *ngIf="!leadLoading; else chartLoader">
                    <!-- <app-lead-time-chart [id]="'leads_status'" [Title]="'Leads Types'" *ngIf="!leadLoading"
                        [data]="leadsAnalytics.leads_status"></app-lead-time-chart> -->
                         <app-pie-chart [id]="'leads_types'" [Title]="'Leads Types'" *ngIf="!leadLoading"
                            [data]="leadsAnalytics.leads_types"></app-pie-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>

            <p-card class=" rounded-xl shadow-lg relative">
                <ng-template pTemplate="header">
                    <div class="flex justify-between items-center p-3 pb-0 absolute top-2 right-4">
                        <div></div>
                        <!-- <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Lead Status</h3> -->
                        <div *ngIf="!isPipelineLoading" class="w-48">
                            <p-select 
                                [options]="pipelineStages" 
                                [(ngModel)]="selectedPipelineId"
                                (onChange)="onPipelineChange($event)"
                                placeholder="Select Pipeline"
                                optionLabel="label"
                                optionValue="value"
                                [style]="{'width': '100%'}"
                                appendTo="body">
                            </p-select>
                        </div>
                        <div *ngIf="isPipelineLoading" class="w-48">
                            <p-skeleton width="100%" height="40px"></p-skeleton>
                        </div>
                    </div>
                </ng-template>

                <div *ngIf="!leadLoading; else chartLoader">
                   <app-lead-time-chart [id]="'leads_status'" [Title]="'Leads Status'" *ngIf="!leadLoading"
                        [data]="leadsAnalytics.leads_status"></app-lead-time-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>

        </div>
    </div>

    <!-- Call and Email communication Tab Content -->
    <div *ngIf="activeTabIndex === 1">
        <h3 class="text-xl font-semibold mb-4">Communication Analytics</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">

            <p-card class="rounded-xl shadow-lg">
                <div *ngIf="!leadLoading; else chartLoader">
                    <app-lead-activity-chart *ngIf="!leadLoading" [data]="leadsAnalytics.lead_calls"
                        [id]="'calls-yearly'" [title]="'Lead Calls - Yearly'" [isDaily]="false" chartType="calls">
                    </app-lead-activity-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>


            <p-card class="rounded-xl shadow-lg">
                <div *ngIf="!leadLoading; else chartLoader">
                    <app-lead-activity-chart *ngIf="!leadLoading" [data]="leadsAnalytics.lead_calls"
                        [id]="'calls-daily'" [title]="'Lead Calls - Daily'" [isDaily]="true" chartType="calls">
                    </app-lead-activity-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>

            <p-card class=" rounded-xl shadow-lg">

                <div *ngIf="!leadLoading; else chartLoader">
                    <app-lead-activity-chart *ngIf="!leadLoading" [data]="leadsAnalytics.email_logs"
                        [id]="'emails-yearly'" [title]="'Email Logs - Yearly'" [isDaily]="false" chartType="emails">
                    </app-lead-activity-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>

            <p-card class=" rounded-xl shadow-lg">

                <div *ngIf="!leadLoading; else chartLoader">
                    <app-lead-activity-chart *ngIf="!leadLoading" [data]="leadsAnalytics.email_logs"
                        [id]="'emails-daily'" [title]="'Email Logs - Daily'" [isDaily]="true" chartType="emails">
                    </app-lead-activity-chart>
                </div>
                <ng-template #chartLoader>
                    <p-skeleton width="100%" height="256px"></p-skeleton>
                </ng-template>
            </p-card>

        </div>

    </div>
</section>